export const generateUuid = () => {
	return window.crypto?.randomUUID ? 
		window.crypto.randomUUID() : 
		Math.random().toString(36).substring(2, 11); // 簡易的な代替
		//Math.random().toString(36).substring(2, 10);
};

export const generateUniqueUuid = (existingIds) => {
	let id = 0;
	do {
		id = generateId();
	} while (existingIds.includes(id))
	return id;
};
